module.exports = __webpack_public_path__ + "img/12-3-fr.ee17d1df.svg";